import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

interface IAdvanceCollectionEligibilityData {
  is_eligible: boolean;
}

interface IAdvanceCollectionEligibilityResponse {
  status: boolean;
  message: string;
  data: IAdvanceCollectionEligibilityData;
}

type IExecuteResponse = {
  status: boolean;
  message: string;
  is_eligible: boolean;
};

export const useAdvanceCollectionEligibilityAPI = () => {
  const configuration = useConfiguration();
  const [isEligible, setIsEligible] = useState<boolean | null>(null);

  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (clinicId: string, userId: string, source: string = "wallet"): Promise<IExecuteResponse> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: IExecuteResponse = await axios
          .get(`${PAYMENT_MODULE?.ADVANCE_COLLECTION_ELIGIBILITY?.baseURL}`, {
            params: {
              clinic_id: clinicId,
              user_id: userId,
              source: source,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IAdvanceCollectionEligibilityResponse>) => {
            if (res.data.status === true) {
              const eligible = !!res.data?.data?.is_eligible;
              setIsEligible(eligible);
              return { status: true, message: res.data?.message ?? "", is_eligible: eligible };
            }
            setIsEligible(false);
            return { status: false, message: res.data?.message ?? "", is_eligible: false };
          })
          .catch((e: AxiosError) => {
            setIsEligible(true);
            sendCurl(e.config["curlCommand"]);
            // captureError(e);
            return { status: false, message: "advance_collection_eligibility_failed", is_eligible: true };
          });
        return response;
      } catch (e: any) {
        setIsEligible(true);
        // captureError(e);
        return { status: false, message: "advance_collection_eligibility_failed", is_eligible: true };
      }
    },
    [dispatch, configuration],
  );

  return { execute, isEligible };
};
